export const TAGS = {
    AUTOMATED: 'AUTOMATED',
    DEMO_DOMAINS: 'DEMO_DOMAIN',
}
